/* import __COLOCATED_TEMPLATE__ from './fly-action-dropdown.hbs.js'; */
import Component from '@glimmer/component';
/**
  This dropdown can be used in situations where we need to present a list of
  actions to be performed.
  We don't want to use a `fly-select`/`fly-power-select` for this, since those
  components are used for selecting an item out of a list, whereas in this
  scenario we simply want something to happen on clicking.

  The items should be passed in as an array into the `@items` prop. The format
  of the individual array item is pretty well described by the
  `FlyActionDropdownItem` type:

  ```
  export type FlyActionDropdownItem = {
    label: string;
    icon?: string;
    classNames?: string;
    disabled?: boolean;
    action?: () => unknown;
    link?: {
      route: string;
      query?: any;
    };
    onMouseEnter?: () => unknown;
    onMouseLeave?: () => unknown;
    tooltip?: {
      condition?: boolean;
      content?: string | number;
      direction?: 'top' | 'top-right' | 'right' | 'bottom-right' | 'bottom' | 'bottom-left' | 'left' | 'top-left';
    };
  };
  ```

  @public
  @class FlyActionDropdown
*/

export default class FlyActionDropdown extends Component {
  get disabled() {
    return this.args.disabled ?? false;
  }
  get renderInPlace() {
    return this.args.renderInPlace ?? true;
  }
  get horizontalPosition() {
    return this.args.horizontalPosition ?? 'auto';
  }
  get verticalPosition() {
    return this.args.verticalPosition ?? 'auto';
  }
}